import React, {useState} from 'react';
import {default as ReactSelect} from 'react-select';
import classes from './Select.module.scss';

const Select = ({id, placeholder, onChange, value, options, error, infoMessage, errorMessage, isClearable}) => {
    const [isChanged, setIsChanged] = useState(false);
    const [hasValue, setHasValue] = useState(!!value);

    const handleChange = (selected) => {
        if (!isChanged) {
            setIsChanged(true);
        }
        setHasValue(!!selected);
        onChange(selected ? selected.value : '');
    };

    return (
        <React.Fragment>
            <ReactSelect
                id={id}
                className={classes.Select + (error && isChanged ? (' ' + classes.Error) : '')}
                classNames={{
                    container: () => classes.Container,
                    control: () => classes.Control,
                    singleValue: () => classes.SingleValue,
                    valueContainer: () => classes.ValueContainer,
                    input: () => classes.Input,
                    placeholder: () => classes.Placeholder,
                    indicatorsContainer: () => classes.Indicator,
                    clearIndicator: () => classes.ClearIndicator,
                    menu: () => classes.Menu,
                    option: (state) => {
                        if (state.isSelected)
                            return classes.SelectedOption

                        if (state.isFocused)
                            return classes.FocusedOption
                        return '';
                    }
                }}
                defaultValue={value}
                onChange={handleChange}
                options={options}
                placeholder={placeholder}
                isClearable={isClearable}
                isSearchable={isClearable ? !hasValue : true}
            />

            {infoMessage &&
            <p className={classes.InfoMessage}>{infoMessage}</p>
            }
            {errorMessage && isChanged &&
            <p className={classes.ErrorMessage}>{errorMessage}</p>
            }
        </React.Fragment>
    );
};

export default React.memo(Select);
